"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _roundTo = _interopRequireDefault(require("round-to"));

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Legend to display info about seat pricing when there are multiple seat pricings available
var SeatMatrixLegend = function SeatMatrixLegend(_ref) {
  var seatPrices = _ref.seatPrices,
      seatInfoByPrice = _ref.seatInfoByPrice;

  // If there's one and only one pricing, don't display anything
  if (!_checkTypes["default"].nonEmptyArray(seatPrices) || seatPrices.length === 1) {
    return null;
  } // Else, build a legend
  // Note: seatPrices is already sorted by price


  var additionalPrices = Array.from(seatPrices);
  additionalPrices.shift();
  var legendElems = additionalPrices.map(function (priceInCents) {
    var _seatInfoByPrice = seatInfoByPrice(priceInCents),
        bgColor = _seatInfoByPrice.freeColor,
        priceDelta = _seatInfoByPrice.priceDelta;

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginRight: 10
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: "seat-legend_".concat(priceInCents),
      style: {
        width: 20,
        height: 20,
        borderRadius: 5,
        backgroundColor: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'gray',
        margin: 5
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {}
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 600
      }
    }, "+$".concat((0, _roundTo["default"])(priceDelta / 100, 2)))));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withPlaceholderFont)({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 15,
      // marginLeft: 20,
      backgroundColor: 'rgba(33, 48, 77, 0.03)',
      borderRadius: 10,
      padding: 7,
      paddingTop: 3,
      paddingBottom: 3 // paddingRight: 15,

    })
  }, legendElems);
};

var _default = SeatMatrixLegend;
exports["default"] = _default;